<template>
    <div class="container"  v-title="'找回密码'">
        <Navigation-bar></Navigation-bar>
        <div class="container_content">
            <Title :title="step == 1 ? '重设账号密码' : '账号验证成功'" :subtitle="step == 1 ? '请注意查收短信验证码' : '请设置新的登录密码'"></Title>
            <div id="ForgetPassword">
                <div class="step1" v-if="step == 1">
                    <div class="content">
                        <ul>
                            <li>
                                <p class="hint" v-text="form.phoneHint"></p>
                                <div class="item-input">
                                    <input type="number" pattern="\d*" :disabled="countDown != 0" v-model.trim="form.phone" @blur="phoneBlur()" maxlength="11" placeholder="请输入手机号">
                                </div>
                            </li>
                            <li>
                                <div class="item-input">
                                    <input type="tel" pattern="\d*" :class="{'error' : form.codeHint}" v-model.trim="form.code" maxlength="6" @blur="codeBlur()" placeholder="请输入验证码">
                                    <span v-if="!form.codeDisabled" class="text-btn" :class="UserType == 1?'s':'c'" @click="sendCode()">获取验证码</span>
                                    <span v-else class="text-btn" style="color: #1B1C1E;" v-text="countDownText"></span>
                                </div>
                                <p class="errorHint" v-text="form.codeHint"></p>
                            </li>
                        </ul>
                    </div>
                    <div class="operation">
                        <button :class="{'disabled' : checkDisabled}" v-pressed @click="checkAccount()">确认</button>
                    </div>
                </div>
                <div class="step2"  v-if="step == 2">
                    <div class="content">
                        <ul>
                            <li>
                                <p class="hint" v-text="form.passwordHint"></p>
                                <div class="item-input">
                                    <input :type="form.pText ? 'password' : 'text'" v-model.trim="form.password" @blur="passwordBlur()" placeholder="输入新密码">
                                    <span class="text-btn" @click="()=>{this.form.pText = !this.form.pText}" v-text="form.pText?'显示':'隐藏'"></span>
                                </div>
                            </li>
                            <li>
                                <div class="item-input">
                                    <input :type="form.vpText ? 'password' : 'text'" :class="{'error' : form.verifyPasswordHint}" v-model.trim="form.verifyPassword" @blur="verifyPasswordBlur()" placeholder="请再次输入">
                                    <span class="text-btn" @click="()=>{this.form.vpText = !this.form.vpText}" v-text="form.vpText?'显示':'隐藏'"></span>
                                </div>
                                <p class="errorHint" v-text="form.verifyPasswordHint"></p>
                            </li>
                        </ul>
                    </div>
                    <div class="operation">
                        <button :class="{'disabled' : forResetDisabled}" v-pressed @click="forResetPassword()">完成</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import { mapGetters } from 'vuex';
import {
    SendVerificationCodeForResetPassword,
    CheckVerificationCodeForResetPassword,
    ResetPassword
} from "@/api"
import { 
    closeWebView
} from "@js/appInteraction"
export default {
    name:"ForgetPassword",
    data(){
        return {
            step: 1,
            form:{
                phone:"",
                phoneHint:"",
                code:"",
                codeHint:"",
                codeDisabled:true,
                password:"",
                passwordHint:"",
                pText:true,
                verifyPassword:"",
                verifyPasswordHint:"",
                vpText:true,
            },
            checkDisabled:true,
            forResetDisabled:true,
            VerificationSerialNumber:"",
            token:"",
            countDown: 0,
            timer: null
        }
    },
    created(){
    },
    beforeDestroy(){
        clearInterval(this.timer);
    },
    computed:{
        ...mapGetters(['UserType']),
        countDownText:function(){
            return this.countDown ? this.countDown + "s" : "";
        }
    },
    watch:{
        "form.phone":function(){
            this.form.phoneHint = "";
            this.form.codeDisabled = true;
            this.checkDisabled = true;
            if(this.form.phone.length == 11){
                if(this.form.phone.substr(0,1) == "1"){
                    this.form.codeDisabled = false;
                    if(this.form.code.length == 6){
                        this.checkDisabled = false;
                    }
                }else{
                    this.form.phoneHint = "请输入正确的格式";
                }
            }else if(this.form.phone.length > 11){
                this.form.phoneHint = "请输入正确的格式";
            }
        },
        "form.code":function(){
            this.form.codeHint = ""; 
            this.checkDisabled = true;
            if(this.form.code.length == 6){
                if(this.form.phone.length == 11 && this.form.phone.substr(0,1) == "1"){
                    this.checkDisabled = false;
                }
            }else if(this.form.code.length > 6){
                this.form.codeHint = "验证码错误"; 
            }
        },
        "form.password":function(){
            this.form.passwordHint = "";
            this.forResetDisabled = true;
            if(this.form.password.length >= 6 && this.form.password.length <= 12){
                if(this.form.verifyPassword == this.form.password){
                    this.forResetDisabled = false;
                }
            }else if(this.form.password.length > 12){
                this.form.passwordHint = "请输入6-12位密码";
            }
        },
        "form.verifyPassword":function(){
            this.form.verifyPasswordHint = "";
            this.forResetDisabled = true;
            if(this.form.verifyPassword == this.form.password){
                if(this.form.password.length >= 6 && this.form.password.length <= 12){
                    this.forResetDisabled = false;
                }
            }else{
                this.form.verifyPasswordHint = "两次密码不一致";
            }
        }
    },
    methods:{
        phoneBlur(){
            this.checkDisabled = false;
            if(this.form.phone.length != 11 || this.form.phone.substr(0,1) != "1"){
                this.form.phoneHint = "请输入正确的格式";
                this.checkDisabled = true;
                return false;
            }
        },
        codeBlur(){
            this.checkDisabled = false;
            if(this.form.code.length != 6){
                this.form.codeHint = "验证码错误";
                this.checkDisabled = true;
                return false;
            }
        },
        passwordBlur(){
            this.forResetDisabled = false;
            if(!(/^[0-9a-zA-Z]{6,12}$/gm.test(this.form.password))){
                this.form.passwordHint = "请输入6-12位数字和字母密码";
                this.forResetDisabled = true;
                return false;
            }
        },
        verifyPasswordBlur(){
            if(this.form.password != this.form.verifyPassword){
                this.form.verifyPasswordHint = "两次密码不一致";
                return false;
            }
        },
        sendCode(){
            if(this.phoneBlur() == false){
                return ;
            }
            SendVerificationCodeForResetPassword({
                MobileNumber: this.form.phone
            }).then(data=>{
                if(data.Code == 0){
                    this.VerificationSerialNumber = data.VerificationSerialNumber;
                    this.countDown = 60;
                    this.form.codeDisabled = true;
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                        this.countDown--;
                        if(this.countDown <= 0){
                            this.form.codeDisabled = false;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                }
            })
        },
        checkAccount(){
            if(this.checkDisabled){
                return ;
            }
            if(this.phoneBlur() == false || this.codeBlur() == false){
                return ;
            }
            CheckVerificationCodeForResetPassword({
                MobileNumber: this.form.phone,
                VerificationSerialNumber: this.VerificationSerialNumber,
                InputVerificationCode: this.form.code
            }).then(data=>{
                if(data.Code == 0){
                    this.token = data.OneTimeToken.Token;
                    this.step = 2;
                } else if([2131, 2132, 2133].indexOf(data.Code) > -1){
                    this.form.codeHint = data.Message;
                }
            })
        },
        forResetPassword(){
            if(this.forResetDisabled){
                return ;
            }
            if(this.passwordBlur() == false || this.verifyPasswordBlur() == false){
                return ;
            }
            ResetPassword({
                MobileNumber: this.form.phone,
                TemporaryToken: this.token,
                _NewPassword: this.form.password
            }).then(data=>{
                if(data.Code == 0){
                    closeWebView();
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .step1,
    .step2{
        height: 100%;
        overflow: hidden;
    }
    .container_content{
        #changePassword {
            height: calc(100% - 158px);
        }
        .title {
            height: 158px;
        }
    }
    .content{
        max-height: 632px;
        min-height: 400px;
        height: calc(100% - 252px);
        padding: 32px 40px 0;
        box-sizing: border-box;
        ul{
            li{
                width: 670px;
                margin: 0 auto;
                margin-bottom: 32px;
                .item-input{
                    width: 670px;
                    height: 112px;
                    position: relative;
                    input{
                        width: 100%;
                        height: 100%;
                        background: #F9F9F9;
                        border-radius: 20px;
                        padding: 0 32px;
                        font-size: 32px;
                        box-sizing: border-box;
                        &.error{
                            background: rgba(240,110,67,0.1);
                        }
                    }
                    .text-btn{
                        @include line-height(40px);
                        font-size: 28px;
                        font-weight: 500;
                        text-align: right;
                        position: absolute;
                        right: 32px;
                        top: 50%;
                        margin-top: -20px;
                        &.s{
                            color: #7AD21A;
                        }
                        &.c{
                            color: #FFA61C;
                        }
                    }
                }
                .hint,
                .errorHint{
                    @include line-height(40px);
                    font-size: 28px;
                    font-weight: 400;
                }
                .hint{
                    color: #8B8C8D;
                    margin-bottom: 8px;
                }
                .errorHint{
                    color: #F06E43;
                    margin-top: 8px;
                }
            }
        }
    }
    .operation{
        height: 100%;
        width: 100%;
        padding-top: 80px;
        box-shadow: 0px 12px 40px -2px rgba(136,136,136,0.25);
        button{
            @include btn-type-large;
            background: #7AD21A;
            box-shadow: 0px 10px 20px 0px rgba(9,144,22,0.25);
            color: #FFFFFF;
            @include btn-state($btn-br);
        }
    }
</style>